import { ChangeEventHandler, Dispatch, useState } from 'react';
import { Button, Dialog, DialogActions, DialogContent, DialogTitle, TextField } from '@mui/material';
import { changeStatus, updateBranch, updateProject } from '../../../entities/project/model/projectSlice';
import { showMessage } from '../../../shared/alert/model/alertSlice';
import { useDispatch, useSelector } from 'react-redux';
import { selectUser } from '../../../entities/auth/model/authSlice';
import { useClient } from '../../../shared/api/useClient';

interface ISubmitDialogProps {
  projectId: string;
}

interface IEditProject {
  token?: string;
  branch?: string;
  projectId: string;
}

export function EditProject({ projectId }: ISubmitDialogProps) {
  const [open, setOpen] = useState(false);
  const [token, setToken] = useState('');
  const [branch, setBranch] = useState('');

  const client = useClient();

  const user = useSelector(selectUser);

  const dispatch = useDispatch();

  const handleOpen = () => {
    setOpen(true);
  };
  const handleClose = () => {
    setOpen(false);
  };

  const onTriggerFormSubmit = async () => {
    try {
      // const body = { projectId } as IEditProject;
      if (branch || token) {
        const payload: { branch?: string; triggerToken?: string } = {};
        if (branch) payload['branch'] = branch;
        if (token) payload['triggerToken'] = token;
        await client.patch(`/projects/${projectId}`, payload);
      }

      // let response;
      // if (token) response = await client.post('/users/project', { triggerToken: token, projectId });

      dispatch(changeStatus());
      if (branch) dispatch(updateBranch({ projectId, branch }));
      dispatch(showMessage({ severity: 'success', message: 'success' }));
    } catch (e) {
      if (e instanceof Error && e.message !== 'canceled')
        dispatch(showMessage({ severity: 'error', message: e.message }));
    }
  };

  return (
    <div>
      <Button variant="outlined" onClick={handleOpen}>
        Edit
      </Button>
      <Dialog open={open} onClose={handleClose} fullWidth>
        <DialogTitle>Edit project</DialogTitle>
        <DialogContent>
          <TextField
            autoFocus
            margin="dense"
            id="dialog-button"
            label="Trigger token"
            fullWidth
            variant="standard"
            value={token}
            onChange={e => setToken(e.target.value)}
          />
          <TextField
            margin="dense"
            id="dialog-button"
            label="Branch"
            fullWidth
            variant="standard"
            value={branch}
            disabled={user?.role.name === 'admin' ? false : true}
            onChange={e => setBranch(e.target.value)}
          />
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose}>Cancel</Button>
          <Button
            onClick={() => {
              onTriggerFormSubmit();
              handleClose();
            }}
          >
            Send
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
}
